import { Box } from '@mui/system'
import { makeStyles } from '@material-ui/core/styles'

const MultiStageSliderLabels = ({ marks, selectedIem, disabled }) => {
  const classes = useStyles()
  const setLabelStyle=(index, length, item)=>{
    return index!==length-1
      ? { left: `${item.value}%` }
      : { right: `0%` }
  }

  return (
    <Box className={classes.root}>
      {marks.length &&
        marks.map((item, index) => (
          <Box
            key={`label_${item.value}`}
            className={`${classes.label} ${
              selectedIem === item.value && !disabled && classes.labelSelected
            }`}
            style={setLabelStyle(index, marks.length, item)}
          >
            {item.label}
          </Box>
        ))}
    </Box>
  )
}

export default MultiStageSliderLabels

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    position: 'relative',
    marginBottom: '10px',
    '& :first-child, :last-child': {
      transform: 'none'
    }
  },
  label: {
    position: 'absolute',
    transform: 'translateX(-50%)',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    ...theme.typography.h3,
    color: theme.palette.primary.main
  },
  labelSelected: {
    color: theme.palette.primary.accent
  }
}))
